"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawer_close = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var drawer_close = function drawer_close(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'drawer-close-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M19.0607 14.25C19.0607 14.6642 18.7249 15 18.3107 15L9.81066 15C9.39645 15 9.06066 14.6642 9.06066 14.25C9.06066 13.8358 9.39645 13.5 9.81066 13.5L18.3107 13.5C18.7249 13.5 19.0607 13.8358 19.0607 14.25Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M6.59099 6.53033C6.88388 6.23744 6.88388 5.76256 6.59099 5.46967C6.2981 5.17678 5.82322 5.17678 5.53033 5.46967L1 10L5.53033 14.5303C5.82322 14.8232 6.2981 14.8232 6.59099 14.5303C6.88388 14.2374 6.88388 13.7626 6.59099 13.4697L3.87132 10.75L18.0607 10.75C18.4749 10.75 18.8107 10.4142 18.8107 10C18.8107 9.58579 18.4749 9.25 18.0607 9.25L3.87132 9.25L6.59099 6.53033Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M18.3107 6.5C18.7249 6.5 19.0607 6.16421 19.0607 5.75C19.0607 5.33579 18.7249 5 18.3107 5L9.81066 5C9.39645 5 9.06066 5.33579 9.06066 5.75C9.06066 6.16421 9.39645 6.5 9.81066 6.5L18.3107 6.5Z',
    fill: '#4B5563'
  }));
};

exports.drawer_close = drawer_close;